import {client, uploaderClient} from '../axios';

import {ResponseError} from "@/types";
import {resolveError} from "@/data/_resolveError";
import {UserProfile, UserProfileItem} from "@/types/UserType";
import {Photo} from "@/types/PhotoType";

export const fetchProfile = (
    success = (profile: UserProfile) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/profile`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const createProfile = (
    title: string,

    success = (profile: UserProfile) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/create`, {title})
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const updateCover = (
    cover_file: File,

    success = (data: {status: string, data: {url: string}}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const formData = new FormData();

    formData.append('cover', cover_file);

    client.post(`/profile/cover`, formData)
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}

export const deleteCover = (
    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.delete(`/profile/cover`)
        .then(({data}: any) => {
            success();
        }).catch((error) => resolveError(error, failed));
}

export const updateProfile = (
    form: UserProfile,

    success = (data: {status: string, data: UserProfile}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/update`, form)
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}

export const addGallery = (
    gallery: string,
    group?: string,

    success = (data: {status: string, data: UserProfileItem}) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/items/add/gallery`, {gallery, group})
        .then(({data}: any) => {
            success(data);
        }).catch((error) => resolveError(error, failed));
}

export const fetchProfileItems = (
    success = (items: UserProfileItem[]) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.get(`/profile/items`)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
}

export const sortItems = (
    items: UserProfileItem[],

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const sorted = items.map(item => item.id);

    client.post(`/profile/items/sort`, {
        sorted,
    })
        .then(({data}: any) => {
            if(data.status === "success") {
                success();
            } else {
                failed(ResponseError.Unknown, {})
            }
        }).catch((error) => resolveError(error, failed));
};

export const sortGroupsItems = (
    groups: Record<string, UserProfileItem[]>,

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const groupNames = Object.keys(groups);
    const sorted: Record<string, string[]> = {};

    groupNames.forEach((groupName) => {
        sorted[groupName] = groups[groupName].map(item => item.id);
    });

    client.post(`/profile/items/sort`, {
        sorted,
        groups: true,
    })
        .then(({data}: any) => {
            if(data.status === "success") {
                success();
            } else {
                failed(ResponseError.Unknown, {})
            }
        }).catch((error) => resolveError(error, failed));
};

export const uploadFile = async (
    file: File,
    group?: string,

    success = (item: UserProfileItem) => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('filename', file.name);
    formData.append('filesize', file.size.toString());
    
    if (group) {
        formData.append('group', group);
    }

    await client.post(`/profile/items/upload`, formData)
        .then(({data}: any) => {
            success(data.data);
        }).catch((error) => resolveError(error, failed));
};

export const deleteItem = (
    item: UserProfileItem,

    success = () => {},
    failed = (type: ResponseError, data: any) => {}
) => {
    client.post(`/profile/items/${item.id}/delete`)
        .then(({data}: any) => {
            if(data.status === "success") {
                success();
            } else {
                failed(ResponseError.Unknown, {})
            }
        }).catch((error) => resolveError(error, failed));
};